// slices/useTimerSlice.ts
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface TimerState {
  elapsedTime: string;
  remainingTime: string;
  isInBufferZone: boolean;
  setElapsedTime: (time: string) => void;
  setRemainingTime: (time: string) => void;
  setIsInBufferZone: (isInBuffer: boolean) => void;
}

export const useTimerSlice = create<TimerState>()(
  devtools(
    (set) => ({
      elapsedTime: '',
      remainingTime: '',
      isInBufferZone: false,
      setElapsedTime: (time) =>
        set({ elapsedTime: time }, false, 'timer/setElapsedTime'),
      setRemainingTime: (time) =>
        set({ remainingTime: time }, false, 'timer/setRemainingTime'),
      setIsInBufferZone: (isInBuffer) =>
        set({ isInBufferZone: isInBuffer }, false, 'timer/setIsInBufferZone'),
    }),
    {
      name: 'Timer Store',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);
